<div class="step-icon-container">
  <div class="step-icon" [ngClass]="{ 'step-done': done, 'step-active': active }" aria-hidden="true">
    @if (done) {
      <svg class="checkmark">
        <use xlink:href="#check"></use>
      </svg>
    } @else {
      {{ step + 1 }}
    }
  </div>
  <span class="text-wrap text-black" [ngClass]="{ 'font-weight-500': active }" aria-hidden="true">{{ label }}</span>
  <span class="visuallyhidden">
    {{ 'label_step_n' | translate: [step + 1] }}
    {{ label }}
    @if (done) {
      {{ 'done' | translate }}
    }
  </span>
</div>
